<template>
  <div>
    <b-card>
      <div class="product-slider">
        <!-- <carousel :perPage="1">
          <slide v-for="(image, index) in product.images" :key="index" class="text-center">
            <img  :src="image" alt="product-image" width="250" height="250" class="product-image"/>
          </slide>
        </carousel>-->
        <!-- <agile> -->
          <div class="slide text-center mb-3">
            <img  :src="product.images[0]" alt="product-image" width="100%" height="280" class="product-image"/>
          </div>
        <!-- </agile> -->
      </div>
      <div class="d-flex justify-content-between mb-2">
        <h4 class="m-0">{{ product.name }}</h4>
        <strong class="m-0">{{ product.price | currency }}</strong>
      </div>
      <!-- <b-card-text v-html="product.description"></b-card-text> -->

      <AddToCartBtn :product="product" />
    </b-card>
  </div>
</template>


<script>
import AddToCartBtn from "./add-to-cart-btn";
export default {
  props: ["product"],
  components: {
    AddToCartBtn
  }
};
</script>

<style lang="scss" scoped>
.product-image {
  object-fit: cover;
}
</style>
